<template>
  <Default>
    <el-row slot="not_children" v-show="isShowDash">
      <el-row :span="24" style="padding-bottom: 0px;">
        <el-col :span="8">
          <div class="min_title">{{$t('menu.supplementManagement')}}</div>
          <div class="flex_vertical order_counts order_count_view">
            <div class="flex_between" :class="i" v-for="(i, index) in orderCounts" :key="i" @click="toOrders(i, 'state')">
              <span>{{$t(`order_state.${i}`)}}</span>
              <span>{{$i18nF('home.orderNum', { count: order_count[i] || 0 })}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="1"><div style="height: 1px"></div></el-col>
        <el-col :span="15">
        <div class="min_title">{{$t('home.overtimeOrders')}}</div>
          <div class="flex_vertical order_counts order_out_times">
            <div class="flex_between out_time" :class="{i, 'marginT10': index > 2, 'red': timeout_count[i.key] > 0}" v-for="(i, index) in outTimes" :key="i.key" @click="toOrders(i.key, 'timeout_type')">
              <span>{{$t(`home.${i.label}`)}}</span>
              <span>{{$i18nF('home.orderNum', { count: timeout_count[i.key] || 0 })}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <div>
        <div class="min_title">{{$t('home.productEcharts')}}</div>
        <div style="overflow: hidden; height: auto">
          <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" size="small" :model="productFilters">
              <el-form-item class="select_input middle_input" :label="$t('home.selectOrderType')">
                <el-radio-group @change="changeOrderType" v-model="productFilters.statistic_order_type" size="small">
                  <el-radio v-for="o in orderTypeEnum" :label="o.id" border :key="o.id">{{$t(o.label)}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item class="select_input middle_input" :label="$t('home.selectMetrics')">
                <el-radio-group v-model="productFilters.statistic_field_type" size="small" @change="changeMetrics">
                  <el-radio v-for="o in fieldEnum" :label="o.id" border :key="o.id">{{$t(o.label)}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="productFilters.statistic_field_type === 'product_item'">
                <el-select
                  v-model="productFilters.product_id"
                  filterable
                  clearable
                  remote
                  :placeholder="$t('common.pleaseSelect')"
                  :remote-method="initProductKeyword"
                  @visible-change="selectFocus"
                  v-el-select-load-more="loadMoreProduct"
                  @change="changeProduct"
                >
                  <el-option
                    v-for="item in productSearchList"
                    :key="item.id"
                    :label="item.caption"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form :inline="true" size="small" :model="productFilters">
              <el-form-item class="select_input">
                <el-date-picker style="width: 335px"  v-model="orderTime" :picker-options="pickerOptions"
                                type="daterange" range-separator="至" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.closingDate')">
                </el-date-picker>
              </el-form-item>
              <el-form-item v-show="productFilters.statistic_order_type === 'order'">
                <el-select :disabled="(curCheckKey !== '' && curCheckKey !== 'state')" @change="changeFilters('state', $event)" v-model="checkOneFilter.state" multiple  :placeholder="$t('supplement.orderStatusS')">
<!--                  <el-option label="所有状态" value=""></el-option>-->
                  <el-option v-for="i in orderStateList" :key="i.key" :label="i.label" :value="i.key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-show="productFilters.statistic_order_type === 'store_order'">
                <el-select v-model="checkOneFilter.state" multiple :placeholder="$t('order.outboundOrderState')">
                  <el-option v-for="i in storeStates" :key="i.key" :label="i.label" :value="i.key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="select_input middle_input">
                <el-select :disabled="!!productFilters.product_id || (curCheckKey !== '' && curCheckKey !== 'purchase_store_type')" @change="changeFilters('purchase_store_type', $event)" v-model="checkOneFilter.purchase_store_type" :placeholder="$t('supplement.orderStatusS')">
                  <el-option label="所有渠道" value=""></el-option>
                  <el-option v-for="i in stopType" :key="i.id" :label="i.label" :value="i.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="select_input max_input">
                <el-select :disabled="!!productFilters.product_id || (curCheckKey !== '' && curCheckKey !== 'produce_factory_key')" @change="changeFilters('produce_factory_key', $event)" v-model="checkOneFilter.produce_factory_key" :placeholder="$t('product.factory')">
                  <el-option label="所有产品厂家" value=""></el-option>
                  <el-option v-for="i in factoryList" :key="i.id" :label="i.name" :value="i.key"></el-option>
                </el-select>
              </el-form-item>
<!--              <el-form-item class="select_input middle_input">-->
<!--                <el-select v-model="productFilters.own_role" :placeholder="$t('common.source')">-->
<!--                  <el-option v-for="i in sourceList" :key="i.key" :label="$t(i.label)" :value="i.key"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
              <el-form-item>
                <el-button type="primary" v-on:click="getProductInfos">{{ $t('common.lookOver') }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" plain v-on:click="resetProduct">{{ $t('common.reset') }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="success" v-on:click="exportExcel">{{ $t('common.export') }}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </div>
        <div id="product_ec">

        </div>
      </div>
      <el-dialog :title="$t('common.detail')" @close="closeCheckDialog" :visible.sync="checkItemDialog" :close-on-click-modal="false">

        <div class="flex_vertical product_item_info" v-if="productFilters.statistic_field_type === 'product_item'">
          <div><strong>{{$t('common.productId')}}：</strong>{{ curProductInfo.product_id }}</div>
          <div><strong>{{$t('product.productModel')}}：</strong>{{ curProductInfo.product_model }}</div>
          <div><strong>{{$t('common.productName')}}：</strong>{{ curProductInfo.caption }}</div>
          <div><el-button size="mini" type="success" v-on:click="exportOneDateExcel">{{ $t('common.export') }}</el-button></div>
        </div>
        <div v-else>
          <el-row class="toolbar":span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" size="mini" :model="this">
              <el-form-item>
                <el-button type="success" v-on:click="exportOneDateExcel">{{ $t('common.export') }}</el-button>
              </el-form-item>
            </el-form>
          </el-row>
        </div>
        <el-table :data="checkItemList" border style="width: 100%">
<!--          <el-table-column prop="id" :label="isItemInfo ? $t('common.partId') : $t('common.productId')" align="center"></el-table-column>-->
          <el-table-column :prop="isItemInfo ? 'unique_number' : 'caption'" :label="isItemInfo ? $t('common.gdsNumber') : $t('common.productName')" align="center"></el-table-column>
          <el-table-column prop="count" :label="$t('common.number')" align="center">
            <template slot-scope="scope">
              {{scope.row.count || 0}}
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBar">
          <el-pagination background @current-change="currentChange" :current-page.sync="c_page" :page-size="c_limit" layout="prev, pager, next, jumper" :total="c_count"></el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeCheckDialog">{{ $t('common.close') }}</el-button>
<!--          <el-button size="small" type="primary" @click="importListToServer">{{$t('supplement.confirmImport')}}</el-button>-->
        </div>
      </el-dialog>
    </el-row>
  </Default>
</template>

<script>
  import Default from '@/components/default';
  import orderFilter from '../../components/order/orderFilter';
  import orderSelectFilter from '../../components/order/orderSelectFilter';
  import productSelect from '../../components/mixins/productSelect';

  import * as echarts from 'echarts';
  import moment from "moment";

  export default {
    name: 'index',
    mixins: [orderFilter, orderSelectFilter, productSelect],
    components: {
      Default
    },
    data() {
      return {
        order_count: {},
        timeout_count: {},
        checkOneFilter: {
          state: [],
          purchase_store_type: '',
          produce_factory_key: '',
        },
        curCheckKey: '',
        productFilters: {
          own_role: '',
          product_id: '',
          statistic_field_type: 'product', // 选择指标
          statistic_order_type: 'order', // 订单类型
        },
        orderTime: null,
        productChart: null,
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
            {
              text: "昨日",
              onClick(picker) {
                const start = new Date();
                start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
                start.setHours(0, 0, 0, 0);
                const end = new Date();
                end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
                end.setHours(23, 59, 59, 0);
                picker.$emit("pick", [start, end]);
              },
            }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        product: {
          url: 'indexStatistic/productSupplementCountStatistics',
          exportUrl: 'exportProductSupplementCountStatistics',
        },
        item: {
          url: 'indexStatistic/itemSupplementCountStatistics',
          exportUrl: 'exportItemSupplementCountStatistics',
        },
        product_item: {
          url: 'indexStatistic/productItemSupplementCountStatistics',
          exportUrl: 'exportProductItemSupplementCountStatistics',
        },
        // 查看折线图中数据详细信息
        currentCheckItem: {}, // 当前查看折线图中的信息
        checkItemList: [],
        c_count: 0,
        c_page: 1,
        c_limit: 20,
        checkItemDialog: false,
        isItemInfo: false,
        curProductInfo: {} , // 当前产品信息
        isShowDash: false
      }
    },
    computed: {
      orderCounts() {
        return [
          'CREATED', 'OFFICER_APPROVED', 'STORE_COLLECTED', 'STORE_SENT'
        ]
      },
      fieldEnum() {
        return [
          { id: 'product', label: 'home.orderCountApply' },
          { id: 'item', label: 'home.itemCountApply' },
          { id: 'product_item', label: 'home.getProductSup' },
        ]
      },
      orderTypeEnum() {
        return [
          { id: 'order', label: 'home.order' },
          { id: 'store_order', label: 'order.outbound' },
        ]
      },
      companyInfo() {
        return this.$store.state.companyInfo;
      }
    },
    mounted() {
      setTimeout(() => {
        if (this.$store.state.companyInfo.is_show_dash) {
          this.isShowDash = true;
          this.initOrderCounts();
          this.initCheckTime();
          this.getProductInfos();
        }
      }, 1000);
    },
    methods: {
      initCheckTime() {
        const that = this;
        const end = new Date();
        let start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        that.orderTime = [];
        that.orderTime[0] = moment(start).startOf('day').toISOString();
        that.orderTime[1] = moment(end).startOf('day').toISOString();
      },
      // 补件管理、超时订单信息
      initOrderCounts() {
        const vm = this;
        vm.$http.get('indexStatistic/orderStateCountStatistics').then((res) => {
          const { status, data } = res;
          if (status === 200) {
            this.order_count = data.data.order_state_count_statistics;
            this.timeout_count = data.data.order_state_timeout_count_statistics;
          }
        })
      },
      toOrders(item, key) {
        const params = {};
        params[key] = item;
        localStorage.setItem('sup_order_save', JSON.stringify(params));
        this.$router.push({
          name: 'supplementManagement'
        })
      },
      resetProduct() {
        this.curCheckKey = '';
        this.checkOneFilter = this.$options.data().checkOneFilter;
        this.productFilters = this.$options.data().productFilters;
        this.initCheckTime();
        this.getProductInfos();
      },
      // 单日参数处理
      setOneDayFilters(callback) {
        const vm = this;
        const  { statistic_field_type, product_id } = vm.productFilters;
        if (statistic_field_type === 'product_item' && !product_id) {
          this.$f.errTip('home.notCheckProduct');
          return;
        }
        const params = {
          ...vm.checkOneFilter,
          ...vm.productFilters,
          ...{
            page: vm.c_page,
            page_size: vm.c_limit,
          }
        }
        const cur_date = vm.currentCheckItem.name;
        params.create_start_time = moment(cur_date).startOf('day').toISOString();
        params.create_end_time = moment(cur_date).add(1, 'day').startOf('day').toISOString();
        callback(params, statistic_field_type)
      },
      // 获取单日信息
      getPartsInfos() {
        const vm = this;
        vm.setOneDayFilters((params, statistic_field_type) => {
          vm.$http.post(vm[statistic_field_type].url, params).then((res) => {
            const { status, data } = res;
            if (status === 200) {
              // console.log(data);
              const { rows, count } = data.data;
              vm.checkItemList = rows;
              vm.c_count = count;
              vm.checkItemDialog = true;
              vm.isItemInfo = statistic_field_type !== 'product';
              vm.curProductInfo = rows[0] || {}
            }
          }).catch(() => {
            vm.currentCheckItem = {};
          })
        })
      },
      // 导出单日数据
      exportOneDateExcel() {
        const vm = this;
        vm.setOneDayFilters((params, statistic_field_type) => {
          vm.$http.post(`indexStatisticExport/${vm[statistic_field_type].exportUrl}`, params).then((res) => {
            const { status, data } = res;
            if (status === 200) {
              vm.urlDownload(data)
            }
          }).catch(() => {
            vm.currentCheckItem = {};
          })
        })
      },
      closeCheckDialog() {
        this.currentCheckItem = {};
        this.checkItemDialog = false
      },
      currentChange(val) {
        this.c_page = val;
        this.getPartsInfos();
      },
      changeFilters(key, val) {
        // this.checkOneFilter = this.$options.data().checkOneFilter;
        // if (val === this.$options.data().checkOneFilter[key] || key === 'state' && val.length === 0) {
        //   this.curCheckKey = '';
        // } else {
        //   this.curCheckKey = key;
        //   this.checkOneFilter[key] = val;
        // }
        // console.log(key)
        // console.log(el)
      },
      changeOrderType() {
        this.checkOneFilter.state = [];
      },
      changeMetrics() {
        this.productFilters.product_id = '';
      },
      changeProduct(val) {
        if (val) {
          this.checkOneFilter.purchase_store_type = '';
          this.checkOneFilter.produce_factory_key = '';
        }
      },
      // 搜索参数处理
      setFilters(callback) {
        const vm = this;
        const  { statistic_field_type, product_id } = vm.productFilters;
        if (statistic_field_type === 'product_item' && !product_id) {
          this.$f.errTip('home.notCheckProduct');
          return;
        }
        const params = {
          ...vm.checkOneFilter,
          ...vm.productFilters
        }
        const { orderTime } = this;
        if (orderTime && orderTime.length === 2) {
          params.create_start_time = moment(orderTime[0]).startOf('day').toISOString();
          params.create_end_time = moment(orderTime[1]).endOf('day').toISOString();
        }
        callback(params)
      },
      // 导出搜索数据
      exportExcel() {
        const vm = this;
        vm.setFilters((params) => {
          vm.$http.post('indexStatisticExport/exportDailyStatistics', params).then((res) => {
            const { status, data } = res;
            if (status === 200) {
              vm.urlDownload(data);
            }
          })
        })
      },
      // 下载excel
      urlDownload(data) {
        const { url } = data.data;
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.click();
        a.remove();
      },
      // 日期信息
      getProductInfos() {
        const vm = this;
        vm.setFilters((params) => {
          vm.$http.post('indexStatistic/dailyStatistics', params).then((res) => {
            const { status, data } = res;
            if (status === 200) {
              vm.initProductEc(data.data);
            }
          })
        })
      },
      // 生成折线图
      initProductEc(data) {
        const vm = this;
        const counts = data.map((r) => r.count);
        const product_caption = data.map((r) => r.date);
        const field = this.fieldEnum.find((f) => f.id === vm.productFilters.statistic_field_type)
        const y_name = vm.$t(field.label);
        const option = {
          // title: {
          //   text: vm.$t('home.productEcharts'),
          // },
          xAxis: {
            type: 'category',
            name: '日期',
            data: product_caption,
            axisLine: {
              show: true,
            },
            axisTick: {
              show: true,
              lineStyle: {
                type: 'solid',
              }
            },
          },
          yAxis: {
            name: y_name,
            type: 'value',
            minInterval: 5,
            splitNumber: 5,
            axisLine: {
              lineStyle: {
              },
              show: true,
            }
          },
          // dataZoom: {

          // },
          series: [
            {
              data: counts,
              type: 'bar',
              smooth: true,
              areaStyle: {
                color: '#82B3E6',
              },
              itemStyle: {
                color: '#82B3E6',
              }
            }
          ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter: function (a) {
              // console.log(a)
              const row = a[0];
              return [
                '日期： ' + row.axisValue + '<hr size=1 style="margin: 3px 0">',
                y_name + '： ' + row.value
              ].join('')
            },
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          }
        };
        const el = document.querySelector('#product_ec');
        vm.productChart = echarts.init(el)
        vm.productChart.setOption(option);
        vm.productChart.off('click');
        vm.productChart.on('click', function (par) {
          if (vm.currentCheckItem.name !== par.name) {
            vm.currentCheckItem = { name: par.name }
            vm.initCheckInfos();
          }
          if (par.componentType == 'series') {
            console.log(par)
          }
        });
        vm.changeProChart(el)
      },
      // 点击查看单日信息
      initCheckInfos() {
        this.c_page = 1;
        this.getPartsInfos()
      },
      changeProChart(el) {
        const vm = this;
        window.addEventListener('resize', () => {
          vm.productChart.resize();
        })
      },
    },

  }
</script>

<style scoped lang="scss">
.min_title {
  font-size: 15px;
  font-weight: bold;
  margin: 20px 0;
}
  .order_counts {
    >div {
      //width: calc(25% - 15px);
      //flex: 1;
      margin-right: 20px;
      border-radius: 10px;
      box-sizing: border-box;
      cursor: pointer;
      color: #131217;
      //transition: 10s width;

      &:last-child {
        margin-right: 0;
      }
      &:hover {
        color: #fff;
        transition: background-color 1s;
      }
    }
    .CREATED {
      background: #FEE9EC;
      &:hover {
        background: #FD3D68;
      }
    }
    .OFFICER_APPROVED {
      background: #E6EEFF;
      &:hover {
        background: #3D8BFF;
      }
    }
    .STORE_COLLECTED {
      background: #EBE3FC;
      &:hover {
        background: #742FDA;
      }
    }
    .STORE_SENT {
      background: #D6EEE2;
      &:hover {
        background: #45CB7E;
      }
    }
    .out_time {
      background: #F6F5FA;
      &:hover {
        background: #FF9A46;
      }
    }
  }
  .order_count_view {
    >div {
      height: 130px;
      padding: 10px 15px;
      animation: 0.5s orderCounts;
      animation-fill-mode: forwards;
      flex-direction: column;
    }
  }
  .order_out_times {
    flex-wrap: wrap;
    >div {
      height: 60px;
      padding: 0 24px;
      animation: 0.5s out_times;
      animation-fill-mode: forwards;
      &:nth-child(3) {
        margin-right: 0;
      }
    }
    .red {
      color: red;
    }
    .marginT10 {
      margin-top: 10px;
    }
  }
  @keyframes orderCounts {
    0% {
      width: 100px;
    }
    100% {
      width: calc(25% - 15px);
    }
  }

  @keyframes out_times {
    0% {
      width: 100px;
    }
    100% {
      width: calc(33% - 15px);
    }
  }

  #product_ec {
    width: 100%;
    height: 500px;
    margin-top: 10px;
  }
  .product_item_info {
    margin-bottom: 10px;
    >div {
      margin-right: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue